module.exports = __webpack_public_path__ + "static/media/arrow-right-circle-red.3132ea8f.png";